<template>
  <v-sheet color="adawhite" style="min-height: 100vh; box-sizing: border-box">
    <v-container
      style="max-width: 750px"
      :class="this.$vuetify.breakpoint.xs ? '' : 'pt-16'"
    >
      <GenericNav>
        <!--<v-bottom-sheet inset>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="mx-2"
              rounded
              dark
              color="nsecondary"
            >
              T <v-icon dark>mdi-cart</v-icon>
            </v-btn>
          </template>
          <Kanttiini /> 
        </v-bottom-sheet>-->
        <HistoryPopup />
        <v-btn to="settings" class="mx-2" rounded dark color="nsecondary">
          <v-icon dark>mdi-cog</v-icon>
        </v-btn>
      </GenericNav>

      <HelloWidget :Usergreeting="Usergreeting" class="d-sm-none" />

      <!--<p class="adaprimary--text">
        Tervetuloa kokeilemaan Kanakorin uutta versiota! Palautetta voit jättää
        oikeassa reunassa olevalla painikkeella
      </p>-->

      <div class="d-flex flex-row">
        <div class="d-flex flex-row flex-wrap justify-center flex-grow-1">
          <v-alert
            icon="mdi-discord"
            color="nsecondary"
            class="rounded-lg"
            dark
          >
            Kanakorin Discord-botin avulla saat ruokalistat suoraan Discordiisi!
            <v-btn
              class="ma-2"
              color="primary"
              href="https://discord.com/oauth2/authorize?client_id=891256458954559488&permissions=0&scope=bot"
              target="_blank"
              >Lisää botti</v-btn
            >
          </v-alert>
          <transition-group name="slide-x-transition" appear>
            <template v-if="Foods.length > 0">
              <v-row :key="1">
                <v-col v-for="food in Foods" :key="food.id">
                  <FoodCard :food="food" />
                </v-col>
              </v-row>
            </template>
            <template v-else-if="!SDKError">
              <v-progress-circular
                size="70"
                :width="7"
                indeterminate
                color="nsecondary"
                class="mx-auto"
                :key="2"
              />
            </template>
            <template v-else>
              <v-alert :key="3" type="error" rounded="lg">
                <v-img
                  src="@/assets/crash.png"
                  max-height="150px"
                  contain
                  class="mr-2"
                  aspect-ratio="1"
                  position="left center"
                />
                SDK-virhe: {{ SDKError }}
                <v-btn
                  class="primary--text"
                  depressed
                  color="nwhite"
                  @click="refresh"
                >
                  <v-icon left dark>mdi-cached</v-icon>Yritä uudelleen
                </v-btn>
              </v-alert>
            </template>
          </transition-group>
        </div>
        <div class="pl-4 d-none d-sm-block">
          <HelloWidget :Usergreeting="Usergreeting" isCard />

          <Adsense
            data-ad-client="ca-pub-1486093574542110"
            data-ad-slot="3165506192"
            style="min-width:250px;"
          >
          </Adsense>

          <transition-group name="slide-x-reverse-transition" appear>
            <template v-if="Ads && Ads.length > 0">
              <AdCollection v-for="ad in Ads" :key="ad._id" :ad="ad" />
            </template>
            <template v-else-if="AdSDKError">
              <v-alert key="1" type="error" rounded="lg">
                SDK-virhe: {{ AdSDKError }}
              </v-alert>
            </template>
          </transition-group>
          <p
            v-if="Ads.length > 0"
            class="text-overline text-center pa-0 ma-0 adaprimary--text"
          >
            Mainokset tarjotaan.
          </p>
        </div>
      </div>
      <GenericFooter />
    </v-container>
  </v-sheet>
</template>

<script>
import { mapState } from "vuex";
import GenericNav from "@/components/layout/GenericNav";
import GenericFooter from "@/components/layout/GenericFooter";
import FoodCard from "@/components/FoodCard";
import AdCollection from "@/components/AdCollection";
import HelloWidget from "@/components/HelloWidget";
import HistoryPopup from "@/components/HistoryPopup";
//import Kanttiini from "@/views/Kanttiini";

export default {
  name: "Home",
  components: {
    GenericNav,
    GenericFooter,
    FoodCard,
    AdCollection,
    HelloWidget,
    HistoryPopup
    //Kanttiini
  },
  computed: {
    Usergreeting() {
      return this.$store.getters["appconfig/getPersonalGreeting"];
    },
    ...mapState({
      Foods: state => state.foods.current,
      SDKError: state => state.foods.sdkerror,
      Ads: state =>
        state.marketing.ads.filter(function(ad) {
          return ad.active;
        }),
      AdSDKError: state => state.marketing.sdkerror
    })
  },
  created() {
    console.log(this.$vuetify.breakpoint);
    this.refresh();
  },
  methods: {
    refresh() {
      this.$store.commit("foods/fixStoreDates");
      this.$store.commit("foods/resetDynComponent");
      this.$store.dispatch("foods/getCurrentFoods");
      this.$store.dispatch("marketing/getAllAds");
    }
  }
};
</script>
